import { APTRINSIC_WIDGET_SELECTOR } from '../const';
import type { State } from '../state';
import { hideFeedbackWidget } from './hideFeedbackWidget';
import { showFeedbackWidget } from './showFeedbackWidget';

export function toggleFeedbackWidget(
  state: State,
  botTarget: HTMLDivElement,
  clickTarget: HTMLDivElement,
) {
  const aptWidgetContainer = document.querySelector(
    APTRINSIC_WIDGET_SELECTOR,
  ) as HTMLDivElement | null;

  if (aptWidgetContainer) {
    if (state.lastClickTarget === clickTarget) {
      hideFeedbackWidget(aptWidgetContainer, botTarget);
    } else {
      showFeedbackWidget(state, aptWidgetContainer, botTarget, clickTarget);
    }
  } else {
    showFeedbackWidget(state, aptWidgetContainer, botTarget, clickTarget);
  }
}
